import React from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import $ from 'jquery';

import {
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex
} from "../../../actions/actionFunctions";
import DesktopNavigationCommon from "../../visComponents/navigation/desktopNavigationCommon";
import Z from "../core/parts/zIndex";
import {Vanity} from "../core/parts/vanity";
import LockedView from "../../common/lockedView";
import {ContentType} from "../../visComponents/constants";
import MobileMenuSelect from "../../visComponents/navigation/mobile/mobileMenuSelect";
import ContextMenu from "./contextMenu";
import {
  setActiveNavigationNames, setNavigationLoading,
  setNavigationViewType,
  toggleDesktopNavigation
} from "../../../actions/navigationFunctions";
import {getCurrentLayout} from "../../appLayout";
import {setVisualizerTutorialStep, showVisualizerTutorial} from "../../../actions/tutorialFunctions";

class DesktopNavigation extends DesktopNavigationCommon {

  bindCanvasClick = (event) => {
    const layout = getCurrentLayout();
    // const canvas = document.getElementById(this.props.canvasId);
    this.props.setHoveredLayer(event);

    if (document.hoveredLayer) {

      const layoutType = layout.getCurrentLayoutName();

      const hoveredZone = Z.getMenuByHoveredLayer(layoutType, document.hoveredLayer);

      // console.log('hoveredZone', hoveredZone);

      if (hoveredZone) {
        if ((hoveredZone === "shower_custom"
          || hoveredZone === "vanity_custom"
          || hoveredZone === "bathtub_custom"
          || hoveredZone === "shower_combo"
          || hoveredZone === "shower_pony_wall"
          || hoveredZone === "wall_b_custom"
          || hoveredZone === "left_wall_custom")
          && !this.state.showNavigation
        ) {
          if (this.state.contextMenuOpen) {
            this.setState({
              contextMenuOpen: false,
              hoveredLayer: {}
            });
          } else {
            let contextMenuOpen = '';
            let ponyWallGroup = false;
            switch (hoveredZone) {
              case "shower_custom":
              case "shower_combo":
              case "shower_pony_wall": {
                const showerGroup = this.state.designNavigationItems.find(navItem => {
                  return navItem.text === "Shower"
                });
                contextMenuOpen = showerGroup.part.showerTubComboIsActive() ? "Shower Tub Combo" : "Shower";
                if (hoveredZone === "shower_pony_wall") {
                  ponyWallGroup = true;
                }
                break;
              }
              case "vanity_custom":
                contextMenuOpen = "Vanity";
                break;
              case "bathtub_custom":
                contextMenuOpen = "Bathtub";
                break;
              case "left_wall_custom":
                contextMenuOpen = "Shower Body Selection";
                break;
              case "wall_b_custom":
                contextMenuOpen = "wall_b_custom";
                break;
            }
            this.openContextMenu(contextMenuOpen, ponyWallGroup, event);
          }
          return false;
        } else if (this.state.contentType === 0) {
          this.setState({
            showNavigation: true,
            contentType: ContentType.Design,
            contextMenuOpen: false,
            hoveredLayer: {}
          }, () => {
            this.setNewActiveFeature();
            this.menuOpened();
            setTimeout(() => {
              $(document).on('click', this.handleWrapperBlur);
            }, 0)
          });
        }

        hoveredZone.child
          ? this.triggerOpenNavigationMenu(hoveredZone.child, hoveredZone.parent)
          : this.triggerOpenNavigationMenu(hoveredZone)

      }

    }

  };

  getShowerBodySelectionButtons = () => {
    const shower = this.state.designNavigationItems.find(desItem => desItem.text === "Shower");
    const currentShowerSize = shower.part.showerSize();
    const showerBody = shower && shower.part.showerBody;
    return (showerBody && showerBody.features.length) ? showerBody.features.filter((showerBodyFeature) => {
      return showerBodyFeature.partName.includes(currentShowerSize);
    }) : [1]
  };

  openContextMenu = (contextMenuOpen, ponyWallGroup, event) => {
    const hoveredParent = this.state.designNavigationItems.find(navItem => {
      return navItem.text === contextMenuOpen
    });
    let contextMenuButtons = [];
    if (contextMenuOpen === "Shower Body Selection") {
      contextMenuButtons = this.getShowerBodySelectionButtons()
    } else if (contextMenuOpen === "wall_b_custom") {
      contextMenuButtons = [1, 2, 3]
    } else {
      contextMenuButtons = hoveredParent.part.subParts();
    }
    if (contextMenuOpen === "Shower" || contextMenuOpen === "Shower Tub Combo") {
      contextMenuButtons = contextMenuButtons.filter(menuButton => {
        return ponyWallGroup ? menuButton.part.isPonyWallPart && menuButton.part.partId !== "pony_wall" : !menuButton.part.isPonyWallPart
      });
    }
    if (contextMenuOpen === "Vanity") {
      contextMenuButtons = contextMenuButtons.filter(menuButton => {
        return menuButton.part.partId !== "vanity_mirror" && menuButton.part.partId !== "vanity_backsplash";
      });
    }

    const isMobile = $(window).width() < 991;

    let left = isMobile ? '50%' : event.clientX - 50;
    let top = isMobile ? '50%' : event.clientY - 50;
    let right = 'auto';

    const maxAllowedWidth = contextMenuButtons.length > 2 ? 300 : 210;

    let maxAllowedHeight = 110;
    if (contextMenuButtons.length > 6) {
      maxAllowedHeight = 330;
    } else if (contextMenuButtons.length > 3) {
      maxAllowedHeight = 220;
    }
    if (!isMobile && (left > window.innerWidth - maxAllowedWidth)) {
      left = 'auto';
      right = 0
    }
    if (!isMobile && (top > window.innerHeight - maxAllowedHeight)) {
      let negativeMargin = 50;
      if (contextMenuButtons.length > 6) {
        negativeMargin = 250;
      } else if (contextMenuButtons.length > 3) {
        negativeMargin = 150;
      }
      top = top - negativeMargin;
    }
    this.setState({
      contextMenuPonyWall: ponyWallGroup,
      contextMenuOpen,
      hoveredLayer: document.hoveredLayer,
      contextMenuPosition: {
        left,
        right,
        top,
      }
    });
  };

  handleNavigationItemClick = (item, ignoreLocked = false, featureIsLocked) => {
    const layout = getCurrentLayout();
    this.navigationItemClickCommon(item);

    const updateSideBarIds = ["shower_body", "wall_configuration", "vanity_cabinet"];
    if (updateSideBarIds.includes(item.part.partId)) {
      this.updateSideBar();
    }
    if (this.state.parentNavigationItem && this.state.parentNavigationItem.text === "Shower Tub Combo"
      && item.part.bottomTubId && (this.state.parentNavigationItem.part.bottomTub !== item.part.bottomTubId)) {
      this.updateSideBar();
    }

    // console.log('this.state.parentNavigationItem', this.state.parentNavigationItem);
    // console.log('this.state.parentNavigationItem.part.subParts()', this.state.parentNavigationItem && this.state.parentNavigationItem.part && this.state.parentNavigationItem.part.subParts());

    if (item.matchesMetaFailed) {
      const nonCompatibleWith = item.part.partId === "vanity_faucet" ? "sink" : "vanity";
      this.callMetaMathesFailedPopup(item, nonCompatibleWith);
    } else if (item.part.partId === "vanity_sink" && this.state.parentNavigationItem.part.faucet
      && this.state.parentNavigationItem.part.faucet.placeholderChanged
      && this.state.parentNavigationItem.part.faucet.activeFeature) {

      const sinkSizeConditionValue = item.part.metaData["SinkSize"][0];

      if (this.state.parentNavigationItem.part.faucet.activeFeature.matchesMetaForCondition('SinkSize', sinkSizeConditionValue)) {
        this.itemClick(item, ignoreLocked)
      } else {
        this.callMetaMathesFailedPopup(item, 'faucet');
      }
    } else if (item.part.partId === "toilet") {
      const vanity = layout.parts[Vanity.id];
      const counterTopSize = vanity.counterTopSize();
      if (counterTopSize === "60in" || counterTopSize === "72in") {
        this.callToiletFailPopup('toilet', item, ignoreLocked)
      } else {
        this.itemClick(item, ignoreLocked)
      }
    } else if (item.part.partId === "vanity_cabinet") {
      // let toilet = layout.parts[Toilet.id];
      // if (toilet) {
      //   toilet = toilet.toilet; // toiletBody
      // }
      // const counterTopSize = item.part.vanitySize + 'in';
      // const vanity = layout.parts[Vanity.id];
      // const currentCounterTopSize = vanity.counterTopSize();
      // if (toilet && toilet.placeholderChanged && (counterTopSize === "60in" || counterTopSize === "72in")
      //   && (currentCounterTopSize !== "60in" && currentCounterTopSize !== "72in")) {
      //   this.callToiletFailPopup('vanity', item, ignoreLocked)
      // } else {
      //   this.itemClick(item, ignoreLocked);
      // }
      this.itemClick(item, ignoreLocked);
      if (this.props.fabricatorSettings
        && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
        ) {
        if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
          this.setWizardFiltersFromActiveItem(item.part)
        }
      }
    } else if (item.part.partId === "shower_interior_wall") {
      if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
        this.setWizardFiltersFromActiveItem(item.part)
      }
      this.itemClick(item, ignoreLocked)
    } else {
      this.itemClick(item, ignoreLocked)
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.refreshCB();
    }
  };

  render() {
    const layout = getCurrentLayout();
    const fabricatorSettings = this.props.fabricatorSettings;
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    const parentItems = layout.designNavigationItems();  // parent list without filters

    let useWizard = false;
    let wizardGroups = [];
    if (fabricatorSettings
      && (fabricatorSettings.wizardConsumers || (fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      && this.state.contentType === ContentType.Design && activeSubPart && activeSubPart.canUseWizard && activeSubPart.allFeaturesReceived) {
      if (activeSubPart.partId === "shower_interior_wall") {
        const featuresToDisplay = activeSubPart.navigationSubItems();
        const tilePatternFilterGroup = this.props.filterGroups.find(group => group.name.trim() === "TilePattern");
        const acrylicPatternFilterGroup = this.props.filterGroups.find(group => group.name.trim() === "AcrylicPattern");
        const tileID = tilePatternFilterGroup && tilePatternFilterGroup.id;
        const acrID = acrylicPatternFilterGroup && acrylicPatternFilterGroup.id;
        useWizard = featuresToDisplay.some(navItem => {
          return (tileID && (navItem.part.dbFeature.filterValueIDs[tileID] || navItem.part.dbFeature.fabFilterValueIDs[tileID]))
            || (acrID && (navItem.part.dbFeature.filterValueIDs[acrID] || navItem.part.dbFeature.fabFilterValueIDs[acrID]))
        })
      } else {
        useWizard = true;
      }
      wizardGroups = this.state[this.getWizardGroupsByPartId(activeSubPart.partId)];
    }
    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = (activePart && activePart.partId === "floor" && activePart.allFeaturesReceived)
      || (activeSubPart && (this.isWallItem(activeSubPart) || activeSubPart.partId === "accent_wall"
        || activeSubPart.partId === "shower_interior_wall_accent") && activeSubPart.allFeaturesReceived);

    const showSmallRoomLayout = fabricatorSettings &&
      (fabricatorSettings.showSmallDesignForClients
        || (fabricatorSettings.showSmallDesignFromDashboard && document.kvConfig.isBackend));

    const availableNavButtons = showSmallRoomLayout
      ? [ContentType.Design, ContentType.Layout, ContentType.DisplayRoom]
      : [ContentType.Design, ContentType.DisplayRoom];

    return (
      <div className={classNames('nav-overlay', {'nav-overlay--fullwidth': this.state.showNavigation})}>
        <div
          className={classNames('nav', {'nav--opened': this.state.showNavigation}, 'nav--' + this.state.contentType)}>
          <div className="nav-wrapper" ref={(node) => this.navWrapper = node}>
            <div className="nav-wrapper__content">
              <div className="nav-wrapper__content-body">
                {this.content(useWizard, wizardGroups, useFilters, activePart, activeSubPart)}
              </div>
              <button className="nav-wrapper__content-close" onClick={this.closeNavigation}/>
            </div>
            {this.navigationMenuButtons(availableNavButtons)}
            {useWizard ? null : (
              <div className="nav-wrapper__select" onClickCapture={this.handleMobileSelectClick}>
                <MobileMenuSelect parentItems={parentItems}
                                  desktop={true}
                                  opened={this.state.showNavigation}
                                  activePart={activePart}
                                  activeSubPart={activeSubPart}
                                  onSubPartClick={this.handleSubPartClick}
                                  onParentItemClick={this.handleParentItemClick}/>
              </div>
            )}
            {/*<div className="nav-wrapper__search">*/}
            {/*<div className="search">*/}
            {/*<input className={"search-input" + (this.state.searchText ? " search-input--no-icon" : "")}*/}
            {/*value={this.state.searchText}*/}
            {/*onChange={this.handleSearchInputChange} placeholder="search"/>*/}
            {/*</div>*/}
            {/*</div>*/}
          </div>
          {this.state.contextMenuOpen
            ? <ContextMenu contextMenuOpen={this.state.contextMenuOpen}
                           hoveredLayer={this.state.hoveredLayer}
                           designNavigationItems={this.state.designNavigationItems}
                           contextMenuPonyWall={this.state.contextMenuPonyWall}
                           contextMenuPosition={this.state.contextMenuPosition}
                           handleContextMenuClick={this.handleContextMenuClick}
                           closeContextMenu={this.closeContextMenu}
                           renderGreenLayerByZindex={this.props.renderGreenLayerByZindex}
            />
            : null}
        </div>
        {showLockedView
          ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
          : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {isPhoneNumberValidated, userIsLoggedIn} = store.userState;
  const {visualizerTutorialStep, visualizerTutorialIsOpened} = store.tutorialState;

  return {
    filtersVisible: store.filterState.showFilters,
    filterGroups: store.filterState.filterGroups,
    bvPresets: store.bathroomVisualizerState.bvPresets,
    isPhoneNumberValidated,
    userIsLoggedIn,
    visualizerTutorialIsOpened,
    visualizerTutorialStep,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
  }
}

const mapDispatchToProps = {
  setNavigationViewType,
  setDefaultSelectionGroup,
  setActiveNavigationNames,
  toggleDesktopNavigation,
  changeActivePartRelatedItemIndex,
  setNavigationLoading,
  setVisualizerTutorialStep,
  showVisualizerTutorial
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopNavigation);
